import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { GuestCaptchaShell } from './components/GuestCaptchaShell';
import './styles.css';
import './propertySetup.css';
import './inspection.css';
import './act.css';
import './close.css';
import './report.css';
import './turnstile.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root element was not found.');
}

createRoot(root).render(
  <StrictMode>
    <GuestCaptchaShell />
  </StrictMode>,
);
